<div class="modal-shell" [ngClass]="{ 'modal-shell--duplicate': variant === 'duplicate-warning' }">
  <div class="modal-header" [ngClass]="{ 'modal-header--duplicate': variant === 'duplicate-warning' }">
    <div class="modal-header__content" *ngIf="variant === 'duplicate-warning'; else defaultHeader">
      <div
        class="modal-header__icon"
        [ngClass]="{
          'modal-header__icon--danger':
            duplicateType === 'siret' || duplicateType === 'siren_siret_mismatch'
        }"
      >
        <i class="fas fa-exclamation-triangle"></i>
      </div>
      <div>
        <h4 class="modal-title" id="modal-title">{{ title }}</h4>
        <p class="modal-subtitle">{{ description || message }}</p>
      </div>
    </div>
    <ng-template #defaultHeader>
      <h4 class="modal-title" id="modal-title">{{ title }}</h4>
    </ng-template>
    <button type="button" class="btn-close" aria-label="Close" (click)="cancel()"></button>
  </div>
  <div class="modal-body" [ngClass]="{ 'modal-body--duplicate': variant === 'duplicate-warning' }">
    <ng-container *ngIf="variant === 'duplicate-warning'; else defaultBody">
      <div class="duplicate-list" *ngIf="duplicateMatches.length > 0">
        <div class="duplicate-card" *ngFor="let match of duplicateMatches">
          <div class="duplicate-card__content">
            <div class="duplicate-card__title">{{ match.name }}</div>
            <div class="duplicate-card__meta">
              <span *ngIf="match.responsible">{{ match.responsible }}</span>
              <span *ngIf="match.companyStatus">{{ match.companyStatus }}</span>
              <span *ngIf="match.createdAt">Créé le {{ formatCreatedAt(match.createdAt) }}</span>
            </div>
            <div class="duplicate-card__ids" *ngIf="match.businessId || match.establishmentId">
              <span *ngIf="match.businessId">SIREN {{ formatSiret(match.businessId) }}</span>
              <span *ngIf="match.establishmentId">SIRET {{ formatSiret(match.establishmentId) }}</span>
            </div>
          </div>
        </div>
      </div>
      <div *ngIf="duplicateMatches.length === 0" [innerHTML]="safeHtml(message)"></div>
    </ng-container>
    <ng-template #defaultBody>
      <div [innerHTML]="safeHtml(message)"></div>
    </ng-template>
  </div>
  <div class="modal-footer" [ngClass]="{ 'modal-footer--duplicate': variant === 'duplicate-warning' }">
    <button type="button" class="btn btn-outline-secondary" (click)="cancel()">{{ cancelButtonText }}</button>
    <button
      type="button"
      class="btn"
      [ngClass]="variant === 'duplicate-warning' ? 'btn-primary' : confirmButtonClass"
      (click)="confirm()"
    >
      {{ confirmButtonText }}
    </button>
  </div>
</div>
